<template>
  <LogoWrapper
    v-if="src"
    :src="src"
    alt="Client Logo"
    :max-height="maxHeight"
    :max-width="maxWidth"
  />
</template>


<script>
import LogoWrapper from './LogoWrapper.vue';

export default {
  name: 'ComponentName',
  components: { LogoWrapper },
  props: {
    maxHeight: {
      type: Number,
    },
    maxWidth: {
      type: Number,
    },
    advisorData: {
      type: Object,
    },
  },
  data() {
    return {
      // This is the advisor data embedded as json in the html document
      // This is a fallback in case the advisorData input is missing
      embeddedAdvisor: null,

      // This allows this component to call the api on it's own
      // Fallback in case all other advisor data sources are missing
      advisorFromAPI: null,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    advisor() {
      return this.advisorData || this.embeddedAdvisor || this.advisorFromAPI;
    },
    src() {
      return this.advisor?.firm?.logo;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.getEmbeddedAdvisor();
    this.getAdvisorFromAPI();
  },
  updated() {},
  methods: {
    getEmbeddedAdvisor() {
      const elem = document.getElementById('ADVISOR_JSON');
      // this.embeddedAdvisor = JSON.parse(elem.textContent)
      this.embeddedAdvisor = null;
    },
    async getAdvisorFromAPI() {
      if (this.embeddedAdvisor) return;
      const opt = { method: 'GET', headers: this.headers };
      const res = await (await fetch('/api/v1/advisor-info', opt)).json();
      this.advisorFromAPI = res.advisor;
    },
  },
};
</script>
